import _ from 'underscore';
import { ITagWithCount } from '../directives/tbTagsInput';
import { ITaggedItemInfo } from '../models/resourceInfoParts';
import { Set } from '../models/Set';

export module TagsHelper {

  export interface ITagsChange {
    addTags: string[];
    removeTags: string[];
  }

  export function tagsListFromTaggedItemSet(taggedSet: Set<ITaggedItemInfo>): ITagWithCount[] {
    const tagCounts: _.Dictionary<number> = {};
    taggedSet.each((taggedItem: ITaggedItemInfo) => {
      _.forEach(taggedItem.tags, (tagName: string) => {
        tagCounts[tagName] = (tagCounts[tagName] || 0) + 1;
      });
    });

    const tagList = _.map(tagCounts, (count: number, tagName: string): ITagWithCount => {
      const tagWithCount: ITagWithCount = {
        name: tagName
      };
      if(taggedSet.size() > count) tagWithCount.count = count;
      return tagWithCount;
    });

    return _.sortBy(tagList, (tag: ITagWithCount) => tag.name.toLowerCase());
  }

  export function tagsListFromTaggedItemArray(taggedSet: any[]): ITagWithCount[] {
    const tagCounts: _.Dictionary<number> = {};
    _.each(taggedSet, ((taggedItem: ITaggedItemInfo) => {
      _.forEach(taggedItem.tags, (tagName: string) => {
        tagCounts[tagName] = (tagCounts[tagName] || 0) + 1;
      });
    }));

    const tagList = _.map(tagCounts, (count: number, tagName: string): ITagWithCount => {
      const tagWithCount: ITagWithCount = {
        name: tagName
      };
      if(taggedSet.length > count) tagWithCount.count = count;
      return tagWithCount;
    });

    return _.sortBy(tagList, (tag: ITagWithCount) => tag.name.toLowerCase());
  }

  export function tagSetFromTagsList(tagList: ITagWithCount[]): Set<ITagWithCount> {
    const tagSet = new Set<ITagWithCount>((tag: ITagWithCount) => tag.name);
    tagSet.addItems(tagList);
    return tagSet;
  }

  export function getTagsChange(previousTagSet: Set<ITagWithCount>, newTagsList: ITagWithCount[]): ITagsChange {
    const changeTags: ITagsChange = {
      addTags: [],
      removeTags: []
    };

    const keepTag: _.Dictionary<boolean> = {};

    _.forEach(newTagsList, (tag: ITagWithCount) => {
      if(tag.added) changeTags.addTags.push(tag.name);

      // A user can re-tag an item.  This is useful if a non-admin wants to add their own tagging to an item
      const tagName = tag.name;
      const previousTag = previousTagSet.get(tagName) || previousTagSet.get(unquote(tagName));
      if(previousTag) keepTag[previousTag.name] = true;
    });

    changeTags.removeTags = _.filter(previousTagSet.keys(), (previousTagName: string) => !keepTag[previousTagName]);

    return changeTags;
  }

  export function parseTagString(tagString: string): string[] {
    const tagList: string[] = [];
    tagString = tagString.replace(/"[^"]*?"/g, function(quotedTag) {
      tagList.push(quotedTag);
      return '';
    });

    const splitTags = _.flatten(_.map(tagString.split(','), (commaSplitTag) => commaSplitTag.split(' ')));
    return _.union<string>(tagList, splitTags);
  }

  export function quote(tag: string): string {
    return _.contains(tag, '"') ? tag : ('"' + tag + '"');
  }

  export function unquote(tag: string): string {
    return tag.replace(/^"([^"]*)"$/, '$1');
  }

  export function displayTagHtml(tag: string): string {
    return _.escape(unquote(tag)).replace(/ /g, '&nbsp;');
  }

}
